<template>
    <sa-page-layout :btnConfigurazioniVisible="true" :btnRefreshVisible="true" :btnNewVisible="false" :linkConfigurazioni="linkConfigurazione" @refresh="onRefresh" :showModalLoading="showModalLoading">
        <template #toolbar>
            <b-button class="button-new" size="sm" variant="success btn-toolbar float-sm-right sa-margin-right" @click="onNew">
                <b-icon icon="plus"></b-icon>
                {{ $t("global.lblBtnNew") }}
            </b-button>
        </template>
        <template #table-filter>
            <div class="sa-list-component-header" style="padding-top: 5px">
                <div class="sa-page-search-component">
                    <b-form style="width: 100%" @submit.prevent="onSubmit">
                        <b-row class="sa-form-btn-filter">
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">Gestore</label>
                                <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                                    <input class="sa-page-search-component-input" v-model="filtroConfigurazioneSim.gestore" placeholder="Inserisci gestore sim.." />
                                </div>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">Iccid</label>
                                <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                                    <input class="sa-page-search-component-input" v-model="filtroConfigurazioneSim.iccid" placeholder="Inserisci iccid sim.." />
                                </div>
                            </b-col>

                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">Stato Attuale</label>
                                <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                                    <input class="sa-page-search-component-input" v-model="filtroConfigurazioneSim.statoAttuale" placeholder="Inserisci stato attuale sim.." />
                                </div>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">Tipo</label>
                                <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                                    <input class="sa-page-search-component-input" v-model="filtroConfigurazioneSim.tipo" placeholder="Inserisci sistema operativo.." />
                                    <button class="sa-page-search-component-btn-search" title="Search">
                                        <i class="fas fa-search"></i>
                                    </button>
                                    <button class="sa-page-search-component-btn-reset" @click="resetFiltriConfigurazioneSim" type="button"><i class="fas fa-trash"></i></button>
                                </div>
                            </b-col>
                        </b-row>
                    </b-form>
                </div>
            </div>
        </template>
        <template slot="table-body">
            <configurazione-device-sim-list-component ref="ConfigurazioneSimListComponent" @afterLoadData="onAfterLoadData" @beforeLoadData="onBeforeLoadData"></configurazione-device-sim-list-component>
        </template>
    </sa-page-layout>
</template>
<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import ConfigurazioneDeviceSimListComponent from "../components/ConfigurazioneDeviceSimListComponent.vue";

export default {
    components: { SaPageLayout, ConfigurazioneDeviceSimListComponent },

    data() {
        return {
            linkConfigurazione: "/configurazionedevice",
            pathResource: "/devicesim",
            showModalLoading: false,
            filtroConfigurazioneSim: {
                tipo: null,
                iccid: null,
                statoAttuale: null,
                gestore: null,
            },
        };
    },
    mounted() {
        let me = this;
        let sessionStorage = window.sessionStorage;
        me.showModalLoading = true;
        let filtroConfigurazioneSim = sessionStorage.getItem("filtroConfigurazioneSim");
        if (filtroConfigurazioneSim) {
            me.filtroConfigurazioneSim = JSON.parse(filtroConfigurazioneSim);
        }
        me.loadData();
    },
    methods: {
        loadData(filtro) {
            let me = this;
            me.onBeforeLoadData();
            me.$refs.ConfigurazioneSimListComponent.loadData(filtro);
        },
        onRefresh() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            me.showModalLoading = true;
            let filtroConfigurazioneSim = sessionStorage.getItem("filtroConfigurazioneSim");
            if (filtroConfigurazioneSim) {
                me.filtroConfigurazioneSim = JSON.parse(filtroConfigurazioneSim);
            }
            me.loadData(me.filtroConfigurazioneSim);
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        resetFiltriConfigurazioneSim() {
            let me = this;
            me.filtroConfigurazioneSim = {
                tipo: null,
                iccid: null,
                statoAttuale: null,
                gestore: null,
            };
            let sessionStorage = window.sessionStorage;
            sessionStorage.setItem("filtroConfigurazioneSim", JSON.stringify(me.filtroConfigurazioneSim));
            this.$refs.ConfigurazioneSimListComponent.loadData(me.filtroConfigurazioneSim);
        },
        onNew() {
            this.$refs.ConfigurazioneSimListComponent.onEdit({ id: "-1", iccid: "", tipo: "", statoAttuale: "", gestore: "" });
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage.setItem("filtroConfigurazioneSim", JSON.stringify(me.filtroConfigurazioneSim));
            me.$refs.ConfigurazioneSimListComponent.loadData();
        },
    },
};
</script>
<style scoped>
.button-new {
    border: 1px solid #218838;
}
</style>
